// BannerOffline.js — Capa 2 del offline del chofer
// Banner fijo que informa el estado de conexión y sincronización.
// No decide nada: solo muestra lo que le pasan por props.
//
// Props:
//   online       -> boolean: hay conexión con el servidor
//   pendientes    -> number: operaciones en la cola de sync
//   sincronizando -> boolean: hay una sincronización en curso
//
// Comportamiento visual:
//   - online y sin pendientes           -> no muestra nada (null)
//   - sin conexión                        -> banner rojo "Sin conexión"
//   - online + sincronizando              -> banner azul "Sincronizando..."
//   - online + pendientes (sin sync aún)  -> banner ámbar "N cambios por enviar"

import React from 'react';

export default function BannerOffline({ online, pendientes = 0, sincronizando = false }) {
  // Nada que mostrar: todo en orden.
  if (online && pendientes === 0 && !sincronizando) return null;

  let estilo = S.offline;
  let icono = '📴';
  let texto = 'Sin conexión — trabajando offline';

  if (!online) {
    estilo = S.offline;
    icono = '📴';
    texto = pendientes > 0
      ? `Sin conexión — ${pendientes} ${pendientes === 1 ? 'cambio' : 'cambios'} por sincronizar`
      : 'Sin conexión — trabajando offline';
  } else if (sincronizando) {
    estilo = S.sync;
    icono = '🔄';
    texto = pendientes > 0
      ? `Sincronizando ${pendientes} ${pendientes === 1 ? 'cambio' : 'cambios'}...`
      : 'Sincronizando...';
  } else if (pendientes > 0) {
    estilo = S.pend;
    icono = '⏳';
    texto = `${pendientes} ${pendientes === 1 ? 'cambio' : 'cambios'} por enviar`;
  }

  return (
    <div style={{ ...S.base, ...estilo }}>
      <span style={S.icono}>{icono}</span>
      <span>{texto}</span>
    </div>
  );
}

const S = {
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '8px 14px',
    fontSize: '13px',
    fontWeight: '600',
    textAlign: 'center',
    position: 'sticky',
    top: 0,
    zIndex: 90,
  },
  icono: { fontSize: '15px', lineHeight: 1 },
  offline: { background: '#CC0000', color: '#fff' },
  sync: { background: '#1e4d8c', color: '#fff' },
  pend: { background: '#b8860b', color: '#fff' },
};
